import React from "react";

const Header = () => {
  const homeActive = window.location.pathname === "/";

  return (
    <header className="gh-header">

      {/* TOP BAR */}
      {/* <div className="top-bar">
        <a href="/" className="top-link active">B2C</a>
        <a
          href="https://business.ghayar.com"
          target="_blank"
          rel="noreferrer"
          className="top-link"
        >
          B2B
        </a>
      </div> */}

      {/* LOGO */}
      {/* <div className="logo-bar">
        <a href="/">
          <img
            src="https://business.ghayar.com/assets/images/Logo/car7_transparent_powered_by.png"
            alt="Ghayar"
          />
        </a>
      </div> */}

      {/* NAV */}
      <nav className="main-nav">
        <ul className="nav-items">
          <li>
            <a href={homeActive ? "#Aboutus" : "/#Aboutus"}>About us</a>
          </li>
          <li>
            <a href={homeActive ? "#Brands" : "/#Brands"}>Brands</a>
          </li>
          <li>
            <a href="/Products">Products</a>
          </li>

          <li>
            <a href={homeActive ? "#People" : "/#People"}>People</a>
          </li>

          <li>
            <a href={"/Career"}>Careers</a>
          </li>


          <li className="login-dropdown">
            <span className="login-trigger">
              Login
              <i className="ri-arrow-down-s-line login-arrow"></i>
            </span>

            <ul className="login-menu">
              <li>
                <a
                  href="https://business.ghayar.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  For Businesses
                  <i className="ri-arrow-right-s-line menu-arrow"></i>
                </a>
              </li>
            </ul>
          </li>


        </ul>
      </nav>

    </header>
  );
};

export default Header;
